import { useEffect, useState } from 'react'

import { HERO_OUTLINE } from '../../../../shared/constants/heroOutline.js'

import { resolveModelOutlineControlsState } from './modelOutlineControlsState.js'

import { LayerLegendPanel } from './LayerLegendPanel.jsx'
import { OutlineLayerSelector } from './OutlineLayerSelector.jsx'

import styles from './ModelControls.module.scss'

const DEFAULT_SELECTOR_WIDTH = '14em'

export function ModelOutlineControlsDock({
  isLoading = false,
  activeView,
  hasSiteModel,
  isOutlineVisible,
  availableOutlines = [],
  activeOutline,
  onOutlineChange,
  onBack,
  colorMode,
  onColorModeChange,
  availableColorModes = [],
  displayableProducts = [],
  legendContainerRef,
  colorModeDeciles = null,
  activeFiltersConfig = null,
  defaultFiltersConfig = null,
  setActiveFiltersConfig,
  activeFiltersCount = 0,
  showSoldHighlightNote = false,
  onShowFilters,
  onLegendHover,
}) {
  const [isLegendOpen, setIsLegendOpen] = useState(true)
  const [isDesktopSelectorExpanded, setIsDesktopSelectorExpanded] = useState(false)

  const {
    showSelectorBackButton,
    useWideOutlineButtons,
    canUseLayerLegend,
    keepSelectorPinned,
  } = resolveModelOutlineControlsState({
    activeView,
    hasSiteModel,
    isOutlineVisible,
    availableOutlines,
    activeOutline,
    displayableProducts,
  })
  const showLegendToggle = canUseLayerLegend && isDesktopSelectorExpanded && !isLegendOpen

  useEffect(() => {
    if (canUseLayerLegend) return
    setIsLegendOpen(false)
    setIsDesktopSelectorExpanded(false)
  }, [canUseLayerLegend])

  if (isLoading) {
    return <span style={{ display: 'block', width: DEFAULT_SELECTOR_WIDTH }} />
  }

  return (
    <div className={styles.outlineSelectorBox}>
      <LayerLegendPanel
        isVisible={canUseLayerLegend}
        isOpen={isLegendOpen}
        showToggle={showLegendToggle}
        onOpen={() => setIsLegendOpen(true)}
        onClose={() => setIsLegendOpen(false)}
        colorMode={colorMode}
        onColorModeChange={onColorModeChange}
        availableColorModes={availableColorModes}
        products={displayableProducts}
        legendContainerRef={legendContainerRef}
        colorModeDeciles={colorModeDeciles}
        activeFiltersConfig={activeFiltersConfig}
        defaultFiltersConfig={defaultFiltersConfig}
        setActiveFiltersConfig={setActiveFiltersConfig}
        activeFiltersCount={activeFiltersCount}
        showSoldHighlightNote={showSoldHighlightNote}
        onShowFilters={onShowFilters}
        onLegendHover={onLegendHover}
      />

      <OutlineLayerSelector
        activeOutline={activeOutline}
        availableOutlines={availableOutlines}
        onOutlineChange={onOutlineChange}
        showBackButton={showSelectorBackButton}
        onBack={onBack}
        useWideOutlineButtons={useWideOutlineButtons}
        keepSelectorPinned={keepSelectorPinned}
        onDesktopExpandedChange={setIsDesktopSelectorExpanded}
      />
    </div>
  )
}